import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { slide as BurgerMenu } from 'react-burger-menu';
import { translate } from 'react-polyglot';
import { NavLink } from 'react-router-dom';
// import moment from 'moment';
import { Button } from './buttons';
import Modal from './Modal';
import Logo from './Logo';
// import { QuestionBubble } from './edu/bubbles';
import { Help, Delete, Plus } from './icons';
import HeaderDropdown from './HeaderDropdown';
import QuestionCreateContainer from '../containers/QuestionCreateContainer';
import './AskListHeaderMenu.css';

// Custom component that embeds a react component inside a translated string.
// This is needed because the underlying node-polyglot library only works with
// strings.
function LogInMessage({ t }) {
  const logInMessageTranslation = t('askList.logInMessage');
  const logInMessageParts = logInMessageTranslation.split(/%{logInLink}/);

  return (
    <Fragment>
      {logInMessageParts[0]}
      <NavLink className="text-link" to="/questions">
        {t('askList.logIn')}
      </NavLink>
      {logInMessageParts.length > 1 && logInMessageParts[1]}
    </Fragment>
  );
}

LogInMessage.propTypes = {
  t: PropTypes.func.isRequired
};

class AskListHeaderMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      burgerMenuOpen: false,
      modalOpen: false
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(e) {
    if (e && e.currentTarget) {
      // force menu to close
      e.currentTarget.blur();
    }

    this.setState(() => ({
      burgerMenuOpen: false,
      modalOpen: true
    }));
  }

  closeModal() {
    this.setState(() => ({
      modalOpen: false
    }));
  }

  closeBurgerMenu() {
    this.setState(() => ({ burgerMenuOpen: false }));
  }

  renderAskList() {
    // TODO: Remove this once client confirms
    // const questionsToRender = (
    //   <div>
    //     <h5>{this.props.t('askList.recentQuestions')}</h5>
    //     {this.props.questions.map(question => (
    //       <QuestionBubble
    //         key={`${question.id}-container`}
    //         colorScheme="blue"
    //         className="ask-list-header-menu__question"
    //       >
    //         <p
    //           key={`${question.id}-question`}
    //           className="ask-list-header-menu__question-contents"
    //         >
    //           {question.question}
    //         </p>
    //         <p
    //           key={`${question.id}-date`}
    //           className="ask-list-header-menu__question-meta text-note"
    //         >
    //           {this.props.t('askList.addedAt', {
    //             date: moment(question.date).format(
    //               this.props.t('shortDateFormat')
    //             )
    //           })}
    //         </p>
    //       </QuestionBubble>
    //     ))}
    //   </div>
    // );

    return (
      <div className="ask-list-header-menu__contents">
        {this.props.profile ? (
          <div>
            <Button
              className="ask-list-header-menu__add-button"
              onClick={this.openModal}
              colorScheme="blue"
            >
              <div className="header-menu-dropdown__link-contents">
                <Plus
                  className="header-button__account-icon header-button__account-icon--logout"
                  width="20"
                  height="20"
                  viewBox="0 0 48 48"
                  fill="white"
                />
                <span>{this.props.t('askList.addAQuestion')}</span>
              </div>
            </Button>
            {/* {this.props.questions.length > 0 ? (
              questionsToRender
            ) : (
              <div className="ask-list-header-menu__no-questions">
                <Help width="32" height="32" viewBox="0 0 32 32" />
                <div>{this.props.t('askList.noQuestions')}</div>
              </div>
            )} */}
            <NavLink
              onClick={() => this.closeBurgerMenu()}
              className="full-width-link header-menu-dropdown__link"
              to="/questions"
            >
              <span>{this.props.t('askList.seeAllQuestions')}</span>
            </NavLink>
          </div>
        ) : (
          <div className="ask-list-header-menu__no-questions">
            <Help />
            <div>
              <LogInMessage t={this.props.t} />
            </div>
          </div>
        )}
      </div>
    );
  }

  render() {
    return (
      <div className="ask-list-header-menu__container">
        <HeaderDropdown
          className="ask-list-header-menu__dropdown"
          onOpen={this.props.fetchAskList}
          displayArrow={false}
          containerWidth="280px"
          title={
            <Help
              width="32"
              height="32"
              viewBox="0 0 32 32"
              label={this.props.t('nav.askList')}
            />
          }
          align="right"
        >
          {this.renderAskList()}
        </HeaderDropdown>
        <BurgerMenu
          tabIndex="-1"
          isOpen={this.state.burgerMenuOpen}
          burgerButtonClassName="ask-list-header-menu__burger-menu"
          right
          width="87.5%"
          menuClassName="burger-menu burger-menu--right"
          overlayClassName="burger-menu-overlay"
          customCrossIcon={<Delete label="close" />}
          customBurgerIcon={<Help label={this.props.t('nav.askList')} />}
          onStateChange={state => {
            this.setState({ burgerMenuOpen: state.isOpen });
            if (state.isOpen) {
              this.props.fetchAskList();
            }
          }}
        >
          <div className="header__menu-header">
            <Logo className="header__menu-logo" type="icon" />
            <h4>{this.props.t('nav.myAskList')}</h4>
          </div>
          {this.renderAskList()}
        </BurgerMenu>
        {this.props.profile && (
          <Modal isOpen={this.state.modalOpen} onRequestClose={this.closeModal}>
            <QuestionCreateContainer onQuestionAdded={this.closeModal} />
          </Modal>
        )}
      </div>
    );
  }
}

AskListHeaderMenu.defaultProps = {
  profile: null
};

AskListHeaderMenu.propTypes = {
  t: PropTypes.func.isRequired,
  fetchAskList: PropTypes.func.isRequired,
  profile: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string
  })
  // questions: PropTypes.arrayOf(
  //   PropTypes.shape({
  //     id: PropTypes.string,
  //     question: PropTypes.string,
  //     details: PropTypes.string,
  //     date: PropTypes.date,
  //     pathname: PropTypes.string,
  //     answered: PropTypes.bool
  //   })
  // ).isRequired
};

export default translate()(AskListHeaderMenu);



// WEBPACK FOOTER //
// ./src/components/AskListHeaderMenu.js